module.exports = __webpack_public_path__ + "static/img/role0011.1666edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0011.jpg
// module id = uBUr
// module chunks = 1